import defaultLocale from './default';

export default defaultLocale;



// WEBPACK FOOTER //
// ./src/components/locale/en_US.tsx